import React from 'react';
import queryString from 'query-string';
import { nprogress } from '@mantine/nprogress';
import Bowser from 'bowser';
import PageWrapper from './src/components/PageWrapper/PageWrapper';
import Cookies from 'js-cookie';

import './src/styles/tailwindStyle.scss';
import { AnalyticData } from '@/interface/analyticData.interface';
import { config } from './src/config';

const defaultAnalytics = {
  sessionStarted: new Date().toISOString(),
  pageView: 1,
  pagesView: [location.href],
};

// Wrap all pages with PageWrapper to ensure context is available everywhere
export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <PageWrapper>{element}</PageWrapper>;
};

export const onClientEntry = () => {
  try {
    const parsed = queryString.parse(window.location.search) || {};
    const parsedWithExtra = { ...parsed } as Record<string, unknown>;
    if (document.referrer) {
      parsedWithExtra.referrer = document.referrer;
    }
    parsedWithExtra.browser = Bowser.parse(window.navigator.userAgent);
    sessionStorage.setItem('utm_source', JSON.stringify(parsedWithExtra));

    let analyticData: Partial<AnalyticData> = defaultAnalytics;

    if (analyticData) {
      analyticData = Cookies.get(config.analytics_cookie)
        ? JSON.parse(Cookies.get(config.analytics_cookie) as string)
        : defaultAnalytics;
    } else {
      analyticData = {
        sessionStarted: new Date().toISOString(),
        pageView: 1,
        pagesView: [location.href],
      };
    }

    Cookies.set(config.analytics_cookie, JSON.stringify(analyticData), { expires: 1 });

    if (!sessionStorage.getItem('landing_page')) {
      sessionStorage.setItem('landing_page', location.href);
    }

    // Function to get URL param
    function getQueryParam(param: string) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }


    if (getQueryParam('gad_campaignid')) {
      localStorage.setItem('disable_ui_ux_form', 'true');
    }
  } catch (e) {
    console.log(e);
  }
};

export const onRouteUpdate = ({ location, prevLocation }: { location: { pathname: string; href: string }; prevLocation?: { pathname: string } }) => {
  if (location.pathname !== prevLocation?.pathname) {
    nprogress.complete();

    try {
      const analyticData: AnalyticData = Cookies.get(config.analytics_cookie)
        ? JSON.parse(Cookies.get(config.analytics_cookie) as string)
        : defaultAnalytics;
      analyticData.pageView = analyticData.pageView + 1;
      analyticData.pagesView.push(location.href);

      Cookies.set(config.analytics_cookie, JSON.stringify(analyticData), { expires: 1 });
    } catch (e) {
      console.log(e);
    }
  }
};

export const onRouteUpdateDelayed = () => {
  nprogress.start();
};
